<template>
	<div>
		<!-- MODAL PARA SOLICITAR A EDICAO -->
		<modal ref="modalSolicitacaoEdicao">
			<div>
				<button type="button" class="close" @click="$refs.modalSolicitacaoEdicao.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{
						motivoModal == 'ASSINATURA'
							? _traducao('global', 'motivoDaEdicao').toUpperCase()
							: _traducao('global', 'solicitacoesEdicao').toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div v-if="tipoExibicao == 'sucesso'">
					<h3 class="text-success">
						<strong><i class="fa fa-fw fa-check-circle"></i>Tudo Certo! </strong><br /><br />
						<span v-if="motivoModal == 'ASSINATURA'">
							{{ _traducao('global', 'assinaturaMotivo') }} {{ _traducao('global', 'vocePodeAtualizar') }}!
						</span>
						<span v-if="motivoModal == 'SOLICITACAO'"> {{ _traducao('global', 'solicitacaoSalvaComSucesso') }}! </span>
						<br /><br />
					</h3>
					<hr />
					<div class="row">
						<div class="col-xs-12">
							<button type="button" @click="$refs.modalSolicitacaoEdicao.modalHide()" class="btn btn-default pull-right">
								{{ _traducao('global', 'fechar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>

				<div v-if="tipoExibicao == 'form'">
					<div class="row form-group">
						<div class="col-xs-12 text-info">
							<i class="fa fa-fw fa-info-circle"></i>
							{{ _traducao('global', 'motivoApareceraDiario') }}.
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<label>{{ _traducao('global', 'motivo') }}:</label>
							<textarea v-model="motivo" class="form-control input-sm" rows="5"></textarea>
						</div>
					</div>

					<hr />

					<div class="row">
						<div class="col-xs-12">
							<button class="btn btn-success pull-right" :disabled="motivo.length < 5" @click="clickSolicitar()">
								<i class="fa fa-fw fa-check"></i> {{ botaoTexto }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			motivo: '',
			idDiarioDeBordo: null,
			tipoExibicao: 'form',
			botaoTexto: '',
			motivoModal: ''
		}
	},

	mounted() {},

	methods: {
		exibirModal(id, motivo) {
			this.idDiarioDeBordo = id
			this.motivo = ''
			this.botaoTexto =
				motivo == 'ASSINATURA'
					? this._traducao('global', 'enviar').toUpperCase()
					: this._traducao('global', 'solicitacao').toUpperCase()
			this.tipoExibicao = 'form'
			this.motivoModal = motivo
			this.$refs.modalSolicitacaoEdicao.modalShow(50)
		},

		clickSolicitar() {
			let post = {
				id: 0,
				justificativa_solicitacao: this.motivo,
				justificativa_resposta: '',
				id_relatorio_voo_trecho: this.idDiarioDeBordo,
				id_usuario: $sessao.getId(),
				status: ''
			}

			bus.$emit('load-in', {text: 'Salvando'})

			this._httpPost('Solicitacao_edicao/salvar', post, (response) => {
				if (response._request && response._status) {
					this.tipoExibicao = 'sucesso'
					this.$emit('solicitacao-salva', response)
				}
				bus.$emit('load-out')
			})
		}
	}
}
</script>